import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { WpService } from '../service/wp.service'

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  page: {};
  loaded: boolean;

  constructor(private wp: WpService, private route: ActivatedRoute) {
  }


  ngOnInit() {
    this.page = undefined
    this.loaded = false;
    this.route.params.subscribe(data => {
      this.wp.get('page/' + data.page).subscribe(
        data => {
          this.page = data
          // if(this.page['blog']){
          //   this.page['blog']["post_content"] = this.page['blog']["post_content"].split('<!--more-->')[0]
          // }
        },
        error => {
          console.error(error)
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// /home/leonhard/Projekte/braungardt/angular/src/app/page/page.component.ts